export default __webpack_public_path__ + "static/media/p2023-5.5f0aa6ef.jpeg";